/**
 * pp-order-produccion — "cómo va tu pedido personalizado" en el detalle de orden.
 *
 * POR QUÉ EXISTE
 * El equipo ve los pasos de impresión en el Print Studio. El cliente no veía
 * nada: su pedido decía "pagado" y ahí se quedaba hasta que le llegaba.
 * Padrino, 13-ago-2026: "que ellos puedan ver cómo va el proceso".
 *
 * LOS PASOS LOS DECIDE EL ENDPOINT, NO ESTE ARCHIVO. Son cuatro y agrupan los
 * siete estados del taller (medido el 3-sep-2026: dos de ellos no se habían
 * usado NUNCA y salían como puntos apagados en medio de la barra). Aquí sólo se
 * pinta lo que llega: agregar o mover un paso se hace allá, en un solo lugar.
 *
 * POR QUÉ SE PIDE EN EL CLIENTE Y NO SE RENDEA EN LIQUID
 * La inmensa mayoría de los pedidos NO llevan personalización. Resolver
 * producción en el render de todos sería una consulta regalada en la mayoría de
 * las cargas. El bloque nace oculto y solo aparece si el endpoint confirma que
 * este pedido sí pasó por el taller.
 *
 * LA AUTORIZACIÓN NO VIVE AQUÍ
 * El `data-pp-order-id` es solo la llave de búsqueda. El edge vuelve a
 * verificar que la orden sea del cliente logueado (o de su empresa) y responde
 * 404 si no — cambiar ese atributo en el navegador no enseña el pedido de otro.
 */
(function () {
  'use strict';

  var RAIZ = document.querySelector('[data-pp-produccion]');
  if (!RAIZ) return;

  var orderId = RAIZ.getAttribute('data-pp-order-id');
  if (!orderId) return;

  var listaEl = RAIZ.querySelector('[data-pp-produccion-pasos]');
  var ligaEl = RAIZ.querySelector('[data-pp-produccion-liga]');
  var avisoLigaEl = RAIZ.querySelector('[data-pp-produccion-liga-aviso]');
  var voboEl = RAIZ.querySelector('[data-pp-produccion-vobo]');

  /* NUNCA UN href QUE VENGA DE UN JSON SIN CAREAR.
     Hoy esa URL la arma nuestro propio edge, así que no es explotable — pero
     `href` es un sumidero: un `javascript:` colado ahí se ejecuta con un clic
     del cliente, y "hoy el origen es de confianza" es una propiedad del
     sistema de HOY, no de este archivo. Cerrarlo cuesta cinco líneas y deja de
     depender de que nadie cambie nunca de dónde sale el dato.

     Se exige https Y el host del estudio: sólo https dejaría pasar una liga a
     un dominio ajeno que se viera igual de legítima. */
  var HOST_ESTUDIO = 'print.parapaquetes.com';
  function ligaSegura(url) {
    if (typeof url !== 'string') return false;
    try {
      var u = new URL(url);
      return u.protocol === 'https:' && u.hostname === HOST_ESTUDIO;
    } catch (e) {
      return false;  // No es ni una URL.
    }
  }

  function pintar(d) {
    if (!d || !d.found || !Array.isArray(d.pasos)) return;

    listaEl.textContent = '';
    d.pasos.forEach(function (paso, indice) {
      /* MISMAS CLASES QUE EL TIMELINE DE ENVÍO (pp-order__status-*). Las dos
         barras viven una encima de la otra; un juego propio de clases era
         tener dos sistemas visuales para la misma idea (Padrino, 4-sep:
         "quiero que tome el mismo formato que el de abajo"). */
      var li = document.createElement('li');
      li.className = 'pp-order__status-step';
      if (paso.completado) li.classList.add('is-done');
      if (paso.actual) li.classList.add('is-active');

      var punto = document.createElement('span');
      punto.className = 'pp-order__status-icon';
      punto.setAttribute('aria-hidden', 'true');
      if (paso.completado) {
        // Palomita, construida con DOM (sin innerHTML): el mismo trazo que
        // usa la tarjeta de envío en Liquid.
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor');
        svg.setAttribute('stroke-width', '2.5');
        svg.setAttribute('stroke-linecap', 'round');
        svg.setAttribute('stroke-linejoin', 'round');
        var palomita = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        palomita.setAttribute('d', 'M20 6 9 17l-5-5');
        svg.appendChild(palomita);
        punto.appendChild(svg);
      } else {
        var numero = document.createElement('span');
        numero.textContent = String(indice + 1);
        punto.appendChild(numero);
      }

      var texto = document.createElement('span');
      texto.className = 'pp-order__status-label';
      texto.textContent = paso.etiqueta;

      li.appendChild(punto);
      li.appendChild(texto);

      /* LA FECHA, SÓLO SI EXISTE. El historial de impresión nació el
         4-sep-2026: los pedidos anteriores llegan con `fecha` en null y se
         pintan igual, sin hueco ni guion. Y "Diseño aprobado" nunca trae fecha
         a propósito — se sabe que ocurrió, no cuándo.

         Mismo formato que la barra de envío ('5 may 2026'), que es la de
         arriba: dos formatos distintos en la misma pantalla se leen como dos
         sistemas distintos. */
      if (paso.fecha) {
        var f = new Date(paso.fecha);
        if (!isNaN(f.getTime())) {
          // Dentro de la etiqueta, como en la tarjeta de envío
          // (<span class="pp-order__status-date"> — 5 may 2026</span>).
          var fecha = document.createElement('span');
          fecha.className = 'pp-order__status-date';
          fecha.textContent = ' — ' + f.toLocaleDateString('es-MX', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
          });
          texto.appendChild(fecha);
        }
      }
      // El paso actual se anuncia a los lectores de pantalla; los demás se leen
      // como lista normal.
      if (paso.actual) li.setAttribute('aria-current', 'step');
      listaEl.appendChild(li);
    });

    // Detenido esperando que el cliente apruebe el diseño. Es el estado que más
    // le importa ver — es el único donde la pelota está de su lado.
    if (voboEl) voboEl.hidden = !d.espera_tu_visto_bueno;


    /* LA LIGA PARA PERSONALIZAR, sólo si el endpoint dice que este pedido
       todavía espera arte del cliente.

       Medido el 4-sep-2026: 35 pedidos PAGADOS tienen al menos un renglón sin
       diseñar. Hoy esa gente ya pagó y no tiene por dónde mandarnos su diseño
       más que WhatsApp.

       El href lo pone el servidor. No se arma aquí concatenando un token
       porque entonces el navegador sabría cómo se construye una liga, y la
       liga es la credencial del pedido. */
    if (ligaEl && d.liga && ligaSegura(d.liga.url)) {
      ligaEl.href = d.liga.url;
      /* Ya aprobado, la liga sigue viva pero cambia de significado: es para
         ver lo que aprobó, no para volver a diseñar. */
      var aprobada = Boolean(d.liga.aprobada_at);
      if (aprobada) {
        ligaEl.textContent = ligaEl.getAttribute('data-texto-aprobada') || ligaEl.textContent;
        ligaEl.classList.add('is-aprobada');
      }
      /* EL AVISO DICE QUÉ FALTA Y QUÉ PASA SI NO LO HACE. Un botón solo no
         explica por qué está ahí; la frase sí, y por eso va ANTES.
         Ya aprobado cambia de texto: dejarlo igual sería mentirle. */
      if (avisoLigaEl) {
        var textoDelAviso = ligaEl.getAttribute(aprobada ? 'data-aviso-aprobado' : 'data-aviso');
        if (textoDelAviso) {
          avisoLigaEl.textContent = textoDelAviso;
          avisoLigaEl.hidden = false;
        }
      }
      ligaEl.hidden = false;
    }

    RAIZ.hidden = false;
  }

  fetch('/apps/crm/customer-produccion?order_id=' + encodeURIComponent(orderId), {
    credentials: 'same-origin',
  })
    .then(function (r) {
      // 404 = no es un pedido personalizado, o no es de este cliente. En los
      // dos casos el bloque se queda oculto y no se dice nada: es el camino
      // normal para casi todos los pedidos, no un error que reportar.
      if (!r.ok) return null;
      return r.json();
    })
    .then(pintar)
    .catch(function () {
      /* Sin conexión o el edge caído: el bloque no aparece y el resto de la
         página funciona igual. Nunca romper el detalle de la orden por esto. */
    });
})();
